import { render } from "./previewCreate.vue?vue&type=template&id=1b4e496c&scoped=true"
import script from "./previewCreate.vue?vue&type=script&lang=js"
export * from "./previewCreate.vue?vue&type=script&lang=js"

import "./previewCreate.vue?vue&type=style&index=0&id=1b4e496c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4e496c"]])

export default __exports__